import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { RecordSgm } from '../data';
import { v4 as uuidv4 } from 'uuid';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { SgmService } from '../../../../services/sgm/sgm.service';

import { LocalDataSource } from 'ng2-smart-table';
import * as moment from 'moment';

type CategoryRow = {
  title: string; answer: 'si' | 'no' | 'na', observation: string;
}

type Row = {
  id: string;
  admon: CategoryRow[];
  events: CategoryRow[];
  program: CategoryRow[];
  system_admon: CategoryRow[];
  operations: CategoryRow[];
  verifications: CategoryRow[];
  inconsistencies: CategoryRow[];
  additional_events: { event: string; observation: string; }[]
}

const dataMock: { [key: string]: CategoryRow[] } = {
  admon: [
    { title: 'Respaldo de la información', answer: 'na', observation: '' },
    { title: 'Cambio en la configuración ', answer: 'na', observation: '' },
    { title: 'Cambio de versión de algoritmo ', answer: 'na', observation: '' },
    { title: 'Alta / baja de usuarios', answer: 'na', observation: '' },
    { title: 'Reemplazo o baja de equipos', answer: 'na', observation: '' },
  ],
  events: [
    { title: 'Reinicio o apagado', answer: 'na', observation: '' },
    { title: 'desconexión de equipos', answer: 'na', observation: '' },
    { title: 'Acceso a la información por otro medio distinto al programa informático', answer: 'na', observation: '' },
  ],
  program: [
    { title: 'Actualización de versión', answer: 'na', observation: '' },
    { title: 'Reinicio del programa informático', answer: 'na', observation: '' },
  ],
  system_admon: [
    { title: 'Error de comunicación del dispositivo de medición', answer: 'na', observation: '' },
    { title: 'Error de transmisión, recepción de archivos y falla en la red', answer: 'na', observation: '' },
  ],
  operations: [
    { title: 'Acceso', answer: 'na', observation: '' },
    { title: 'Consulto', answer: 'na', observation: '' },
    { title: 'revisión de bitácoras', answer: 'na', observation: '' },
    { title: 'Registro de alarmas', answer: 'na', observation: '' },
    { title: 'Operaciones de mantenimiento ', answer: 'na', observation: '' },
    { title: 'Toma de muestras', answer: 'na', observation: '' },
  ],
  verifications: [
    { title: 'Por autoridad fiscal o proveedores autorizados SAT', answer: 'na', observation: '' },
  ],
  inconsistencies: [
    { title: 'Diferencias de más del 0.5%', answer: 'na', observation: '' },
    { title: 'Volumen igual al día anterior, con entradas registradas', answer: 'na', observation: '' },
    { title: 'Volumen es menor a cero', answer: 'na', observation: '' },
    { title: 'Volumen varia con respecto al día anterior, con entradas y salidas registradas', answer: 'na', observation: '' },
    { title: 'Volumen de salidas es mayor al volumen de entradas ', answer: 'na', observation: '' },
  ],
};

const emptyForm: Row = {
  id: '',
  admon: dataMock.admon,
  events: dataMock.events,
  program: dataMock.program,
  system_admon: dataMock.system_admon,
  operations: dataMock.operations,
  verifications: dataMock.verifications,
  inconsistencies: dataMock.inconsistencies,
  additional_events: [],
};

@Component({
  selector: 'ngx-sgm-anexo-diez',
  templateUrl: './anexo-diez.component.html',
})
export class AnexoDiezComponent implements OnInit {
  @Input() stationId: string;
  @Input() record: RecordSgm;
  @Output() recordChange = new EventEmitter<Partial<RecordSgm & { row: any, event: string }> >();
  source: LocalDataSource;
  row = { ...emptyForm }
  loading = false
  settings = {
    actions: {
      columnTitle: 'Acciones',
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'download',
          title: '<img src="assets/images/icons/download.png" width="25px">',
        },
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.png" width="25px">',
        },
        {
          name: 'delete',
          title: '<img src="assets/images/icons/delete.png" width="25px">',
        },
      ],
    },
    pager: {
      perPage: 10,
    },
    columns: {
      admon: {
        title: 'Respaldo de la información',
        filter: true,
        valuePrepareFunction: (item) => item[0].answer + ', ' + item[0].observation
      },
      events: {
        title: 'Reinicio o apagado',
        filter: true,
        valuePrepareFunction: (item) => item[0].answer + ', ' + item[0].observation
      },
      program: {
        title: 'Actualización de versión',
        filter: true,
        valuePrepareFunction: (item) => item[0].answer + ', ' + item[0].observation
      },
      system_admon: {
        title: 'Error de comunicación del dispositivo de medición',
        filter: true,
        valuePrepareFunction: (item) => item[0].answer + ', ' + item[0].observation
      },

    },
    noDataMessage: 'Sin registros',
  };

  constructor(private sgmService: SgmService) {}

  ngOnInit() {
    this.loadData()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.record.currentValue.rows) {
      this.source = new LocalDataSource(changes.record.currentValue.rows)
    }
  }

  async onCustom(event: { action: string; data: Row; }) {
    this.row = event.data;
    if (event.action === 'delete') {
      // @ts-ignore
      $('#delete-document').modal('show');
    } else if (event.action === 'edit') {
      // @ts-ignore
      $('#create-document').modal('show');
    } else if (event.action === 'download') {
      this.download();
    }
  }

  async remove () {
    this.recordChange.emit({ ...this.record, rows: [], row: this.row, event: 'delete' })
    this.record.rows = this.record.rows.filter(row => row.id !== this.row.id)
    this.loadData()
    // @ts-ignore
    $('#delete-document').modal('hide');
  }

  async storeOrUpdate () {
    this.recordChange.emit({ ...this.record, rows: [], row: this.row, event: this.row.id ? 'edit' : 'create' })
    this.loadData()
    // @ts-ignore
    $('#create-document').modal('hide');
  }

  loadData () {
    this.row = { ...emptyForm };
    this.source = new LocalDataSource(this.record.rows)
  }

  addEvent () {
    this.row.additional_events.push({ event: '', observation: '' })
  }

  removeToArray (index: number, rows: Array<any>) {
    rows.splice(index, 1)
  }

  async download () {
    await this.sgmService.downloadFormat({
      stationId: this.stationId,
      category: this.record.category,
      file: this.record.key,
      id_item: this.row.id
    });
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
